import CodementumLoader from '@cm-frontend/commons/loading';
import userStateModule from '@cm-frontend/commons/user-state-module';
import CodementumNavbarPlugin from '@cm-frontend/panel-navbar';
import { registerAsyncBlockDirective } from '@cm-frontend/shared/vue/async-block-directive';
import Ionic from '@ionic/vue';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

import VueEvents from '@/events.js';
import VuexVueEvents from '@/store/events.js';
import store from '@/store/index';

import i18n from './i18n/all';
// Internal imports
import MainComponent from './main.vue';
import router from './router';
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Ionic);
Vue.use(CodementumLoader); // #Ref-2
Vue.use(CodementumNavbarPlugin, {
  store,
  axios,
  storeMerge: {
    modules: {
      state: userStateModule() // @param Special axios instance
    }
  },
  i18n,
  mode: import.meta.env.MODE,
  pkgVersion: import.meta.env.VITE_PKG_VERSION
});

// General event bus.
Vue.prototype.$eventBus = new Vue();

Vue.use(registerAsyncBlockDirective);

// Create vue instance
new Vue({
  beforeCreate() {
    VuexVueEvents(store, this.$root);
    VueEvents(this.$root);
  },
  data() {
    return {
      settings: {
        designElementsOrder: {
          // component-name: "title"
          components: 'Components',
          plugins: 'Plugins',
          services: 'Services'
        }
      }
    };
  },
  router,
  // @ts-ignore
  store,
  render: (h) => h(MainComponent)
}).$mount('#appmaker');
